var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "701.378 -1689.377 118.352 148.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0078d6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_12_1",
    "data-name": "Symbol 12 \\u2013 1",
    transform: "translate(701.378 -1689.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M59.126,7.121,111.231,23.67V89.817c0,5.567-2.056,11.384-6.068,17.251C100.75,113.488,93.98,120.007,85,126.476a168.216,168.216,0,0,1-25.877,15.245,168.212,168.212,0,0,1-25.877-15.245c-8.977-6.469-15.747-13.039-20.16-19.408C9.077,101.2,7.021,95.384,7.021,89.817V23.67L59.126,7.121m0-7.121a5.592,5.592,0,0,0-1.555.251L3.561,17.4A5.118,5.118,0,0,0,0,22.266V89.817c0,14.092,9.779,28.334,29.137,42.326A173.049,173.049,0,0,0,57.07,148.492a4.965,4.965,0,0,0,2.106.451,5.31,5.31,0,0,0,2.106-.451,175.447,175.447,0,0,0,27.933-16.349c19.307-13.992,29.137-28.234,29.137-42.326V22.266a5.166,5.166,0,0,0-3.561-4.864L60.681.251A5.31,5.31,0,0,0,59.126,0Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(39.367 35.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M94,71.1a2.5,2.5,0,0,0-.853.05V84.189A15.587,15.587,0,0,0,94.4,115.332h7.623a5.377,5.377,0,1,1,0,10.732H78.5v10.23H93.144v10.331h10.23V136.244A15.587,15.587,0,0,0,102.12,105.1H94.5a5.377,5.377,0,1,1,0-10.732h22.166l-.1-5.216-.05-4.965H103.474V71.15H97.356c-.9,0-2.407-.05-3.36-.05Z",
    transform: "translate(-78.5 -71.1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionDetails);
export default __webpack_public_path__ + "static/media/transaction-details.fdab133e67a13b001f4a9e4938be0ff3.svg";
export { ForwardRef as ReactComponent };